import { render } from "./ProProdutosView.vue?vue&type=template&id=2ef566a9&scoped=true"
import script from "./ProProdutosView.vue?vue&type=script&lang=js"
export * from "./ProProdutosView.vue?vue&type=script&lang=js"

import "./ProProdutosView.vue?vue&type=style&index=0&id=2ef566a9&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef566a9"]])

export default __exports__